var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrackingTabLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 56,
    viewBox: "0 0 62 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5312 41.0062L25.465 53.5488L1.5 41.0068V14.712L25.465 2.56036L49.5312 14.7126V41.0062Z",
    stroke: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 41.0065V15.2301L25.0156 27.5113V53.2877L1.5 41.0065Z",
    stroke: "#BDBDBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4645 54.1129L50.0312 41.3095V14.4049L25.4645 2L1 14.4049V41.3095L25.4645 54.1129Z",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.4049L25.5156 27.2083L50.1435 14.4049",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5149 27.545V54.1124",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.992 53.3017C58.9671 54.3269 57.3136 54.3269 56.2887 53.3017L51.9279 49.2785C50.9029 48.2534 50.9029 46.59 51.9279 45.5745C52.9528 44.5494 54.6062 44.5494 55.6312 45.5745L59.992 49.5977C61.0169 50.6228 61.0169 52.2766 59.992 53.3017Z",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6554 47.2957C48.5402 47.2957 53.3108 42.5285 53.3108 36.6479C53.3108 30.7672 48.5402 26 42.6554 26C36.7706 26 32 30.7672 32 36.6479C32 42.5285 36.7706 47.2957 42.6554 47.2957Z",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackingTabLink);
export default __webpack_public_path__ + "static/media/tracking-tab-link.274771bb.svg";
export { ForwardRef as ReactComponent };